<ion-menu contentId="main-content" side="start" type="overlay" swipe-gesture="false">
  <ion-header>
    <ion-toolbar>
      <!-- <ion-title>Menu</ion-title> -->
      <div class="menu-img">
        <!-- <img class="menu-pic" src="assets/images/profile-avatar.svg"> -->
        <img class="menu-pic" [src]="profileImagePath">
        <span class="menu-text">{{storageObject.firstName}} {{storageObject.lastName}}</span>
        <span class="menu-sub-text">{{storageObject.jobTitle}}</span>
      </div>
    </ion-toolbar>
  </ion-header>
  <ion-content class="bg-color white sidebar">
      <ng-container *ngFor="let p of navMenuitems;let i=index">
        <ion-menu-toggle auto-hide="false" *ngIf="p.isMenuActive">
          <ion-item *ngIf="p.drop == false" [routerDirection]="'forward'" (click)="route(p)" lines="none" detail='false' id="nav_menu_{{p.label}}">
            <!-- <ion-icon slot="start" src="{{p.icon}} | safeUrl"> -->
            <img class="icon-menu" [src]="p.icon | safeUrl">
            <!-- </ion-icon> -->
            <ion-label>
              {{p.label}}
            </ion-label>
          </ion-item>
        </ion-menu-toggle>
        <ion-item *ngIf="p.drop == true && p.isMenuActive" lines="none" id="nav_menu_{{p.label}}" class="{{p.class}}" (click)="toggleDropdown(p.label)">
          <!-- <ion-icon slot="start" src="{{p.icon}} | safeUrl"> -->
          <img class="icon-menu" [src]="p.icon | safeUrl">
          <!-- </ion-icon> -->
          <ion-label>
            {{p.label}}
          </ion-label>
          <ng-container *ngIf="p.submenu">
            <mat-icon *ngIf="p.isSubMenuActive == false" class="ic01" style="margin-top:12px">add</mat-icon>
            <mat-icon *ngIf="p.isSubMenuActive == true" class="ic01" style="margin-top:12px">remove</mat-icon>
            <!-- <ion-icon slot="end" *ngIf="p.isSubMenuActive == false" name="add" class="ic01" style="margin-top:12px"></ion-icon>
            <ion-icon slot="end" *ngIf="p.isSubMenuActive == true" name="remove" class="ic01" style="margin-top:12px"></ion-icon> -->
          </ng-container>
        </ion-item>
        <ion-menu-toggle auto-hide="false" *ngIf="p.isSubMenuActive">
          <ion-list *ngIf="p.submenu" style="background-color: #f7f7f7; padding-left: 63px">
            <ng-container *ngFor="let item of p.submenu">
              <ion-item *ngIf="item.isActive == true"  [routerDirection]="'forward'" (click)="route(item)" id="nav_menu_{{p.label}}"
              lines="none">
                <ion-label >
                  {{ item.label }}
                </ion-label>
              </ion-item>
            </ng-container>
          </ion-list>
        </ion-menu-toggle>
      </ng-container>
  </ion-content>
  <ion-footer class="bg-color white">
    <ion-toolbar>
      <div class="footer-img">
        <span>Powered by</span>
        <img [src]="bizdataLogo">
      </div>
    </ion-toolbar>
  </ion-footer>
</ion-menu>